import React, { Component } from 'react';
import styles from './PersonsFormSection.module.scss';
import AddedPerson from './AddedPerson';
import { ObjectsPopupSelector, Button } from 'components';
import { observer, inject } from 'mobx-react';
import { PERSON_STORE, PersonStore } from 'store';

interface Props {
  label: string;
  personsList: any[];
  setPersonsList: (list: any[]) => void;
  [PERSON_STORE]?: PersonStore;
}

interface State {
  showPopup: boolean;
}

class PersonsFormSection extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { showPopup: false };

    this.handleRemovePerson = this.handleRemovePerson.bind(this);
    this.handleAddPersonClick = this.handleAddPersonClick.bind(this);
  }

  handleRemovePerson(id: number) {
    const {
      personsList: propsPersonsList,
      setPersonsList
    } = this.props;

    const personsList = [...propsPersonsList];
    const index = personsList.findIndex(p => p.id === id);
    if (index < 0) return;

    personsList.splice(index, 1);
    setPersonsList(personsList);
  }

  handleAddPersonClick() {
    const {
      [PERSON_STORE]: { personsList: storePersons, getAll }
    } = this.props;
    if (!storePersons.length) getAll();

    this.setState({ showPopup: true });
  }

  render() {
    const {
      label,
      personsList,
      setPersonsList,
      [PERSON_STORE]: { personsList: storePersons }
    } = this.props;
    const { showPopup } = this.state;

    return (
      <div className={styles.container}>

        <label>{label}</label>

        <div className={styles.personsContainer}>

          <div className={styles.innerContainer}>
            {personsList.map(person =>
              <AddedPerson
                key={person.id}
                person={person}
                removePerson={this.handleRemovePerson}
              />
            )}
          </div>

          <Button
            type='add'
            size='small'
            onClick={this.handleAddPersonClick}
          >
            Add Person
          </Button>

        </div>

        {showPopup &&
          <ObjectsPopupSelector
            title={`manage ${label} of your project`}
            onClose={() => this.setState({ showPopup: false })}
            objectsList={storePersons}
            selectedObjectsList={personsList}
            setSelectedList={setPersonsList}
          />
        }

      </div>
    );
  }
}

export default inject(PERSON_STORE)(observer(PersonsFormSection));
